import { render, staticRenderFns } from "./MaterialDonationProductsList.vue?vue&type=template&id=7cda8c9e&"
import script from "./MaterialDonationProductsList.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports